module.exports = __webpack_public_path__ + "img/ITA.7f9aa3bb.png";